var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};
var MultiSelectDropdown = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.dropdownLabel, dropdownLabel = _c === void 0 ? 'Select Items' : _c, dropdownStyle = _a.dropdownStyle, muiSelectProps = _a.muiSelectProps, initialValue = _a.initialValue, required = _a.required, onChange = _a.onChange;
    var _d = __read(useState([]), 2), selectedItems = _d[0], setSelectedItems = _d[1];
    useEffect(function () {
        if (Array.isArray(initialValue)) {
            setSelectedItems(initialValue);
        }
    }, [initialValue]);
    var handleChange = function (event) {
        setSelectedItems(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
    };
    return (React.createElement("div", null,
        React.createElement(FormControl, { sx: __assign({ m: 1, width: 300 }, dropdownStyle) },
            React.createElement(InputLabel, { id: "demo-multiple-checkbox-label" },
                dropdownLabel,
                required ? React.createElement("span", { className: "lfc-text-red-500" }, "*") : null),
            React.createElement(Select, __assign({ labelId: "demo-multiple-checkbox-label", id: "demo-multiple-checkbox", multiple: true, value: selectedItems, onChange: handleChange, input: React.createElement(OutlinedInput, { label: dropdownLabel }), renderValue: function (selected) {
                    // map selected values to their labels
                    return "".concat((selected || [])
                        .map(function (item) {
                        var option = options.find(function (option) { return option.value === item; });
                        return (option === null || option === void 0 ? void 0 : option.label) || '';
                    })
                        .slice(0, 2)
                        .join(', '), " ").concat(selected.length > 2 ? ", +".concat(selected.length - 2, " more") : '');
                }, MenuProps: MenuProps }, muiSelectProps), options.map(function (option) { return (React.createElement(MenuItem, { key: option.label, value: option.value },
                React.createElement(Checkbox, { checked: selectedItems.includes(option.value) }),
                React.createElement(ListItemText, { primary: option.label }))); })))));
};
export default MultiSelectDropdown;
//# sourceMappingURL=MultiSelectDropdown.js.map